module.exports = __webpack_public_path__ + "img/imageContent4.1aeb65ec.jpg";